import React, { useEffect } from 'react'

import Cookies from 'js-cookie'

function Logout() {
  let stop:any = Date.now();
  const clearCookies=()=>{
    Cookies.remove('app_tcpcdk')
     Cookies.remove('app_tcscdk')	
  localStorage.setItem('_spexpt', stop)
  localStorage.setItem('_spbexpt', stop)
  }
  
  useEffect(()=>{
    clearCookies()

    setTimeout(() => {
      window.location.href='/'
    }, 1000);
  }, [])

  return (
    <div>...please wait...</div>
  )
}

export default Logout